var _path, _path2, _circle, _circle2, _circle3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsLauEmY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 25.8366 8.16344 33 17 33C25.8366 33 33 25.8366 33 17C33 8.16344 25.8366 1 17 1C12.4152 1 8.28078 2.92841 5.36364 6.01836",
    stroke: "#2593FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9331 27.371C25.0335 24.4558 21.1007 22.8181 17 22.8181C12.8993 22.8181 8.96654 24.4558 6.06689 27.371",
    stroke: "#2593FF",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9998,
    cy: 12.6363,
    r: 5.81818,
    stroke: "#2593FF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 10,
    r: 1,
    fill: "#2593FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 27,
    r: 8,
    fill: "#E9F8FF",
    stroke: "#22BF76",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 23,
    x2: 32,
    y2: 31,
    stroke: "#22BF76",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 27,
    x2: 28,
    y2: 27,
    stroke: "#22BF76",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsLauEmY);
export default __webpack_public_path__ + "static/media/msLauEmY.d0cb1cc787fdc7540537a4826f3a2b72.svg";
export { ForwardRef as ReactComponent };